/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class FooterAccordion extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.summaryIsEmpty = this.summaryToggle.textContent.trim().length == 0;
    this.detailsContainer.addEventListener('keyup', event => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    document.addEventListener('matchSmall', this.close.bind(this));
    document.addEventListener('unmatchSmall', this.open.bind(this));
    if (!theme.config.mqlSmall || this.summaryIsEmpty) {
      this.open();
      if (this.summaryIsEmpty) {
        this.detailsContainer.setAttribute('empty', true);
      }
    } else {
      if (this.dataset.open == undefined) this.close();
    }
  }
  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open();
  }
  closeOtherAccordions() {
    if (!theme?.config?.mqlSmall) return;
    [...document.querySelectorAll('footer-accordion')].filter(acc => acc !== this && acc.detailsContainer && !acc.summaryIsEmpty).forEach(acc => {
      acc.detailsContainer.removeAttribute('open');
      const summary = acc.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    });
  }
  open() {
    this.closeOtherAccordions();
    this.detailsContainer.setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', 'true');
  }
  close() {
    if (theme.config.mqlSmall && !this.summaryIsEmpty) {
      this.detailsContainer.removeAttribute('open');
      this.summaryToggle.setAttribute('aria-expanded', 'false');
    }
  }
}
customElements.define('footer-accordion', FooterAccordion);
/******/ })()
;